import script from "./HTpvpGamePlay.vue?vue&type=script&setup=true&lang=js"
export * from "./HTpvpGamePlay.vue?vue&type=script&setup=true&lang=js"

import "./HTpvpGamePlay.vue?vue&type=style&index=0&id=664041b8&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-664041b8"]])

export default __exports__